exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confessionItem[data-v-430cef3e]{min-height:300px;width:300px;background:#fafad2;border-radius:5px;padding:10px;margin:7px}.confessionText[data-v-430cef3e]{min-height:200px;font-size:15px;font-family:Roboto,sans-serif;display:flex;align-items:center;justify-content:center;text-align:center;word-wrap:break-word}.metaItem[data-v-430cef3e]{display:flex;align-items:center;padding:10px}.metaText[data-v-430cef3e]{position:relative;font-family:Roboto,sans-serif;top:-1px;left:10px}.comment[data-v-430cef3e]{position:relative;top:-1px}.tagContainer[data-v-430cef3e]{flex-wrap:wrap}.tag[data-v-430cef3e],.tagContainer[data-v-430cef3e]{display:flex;justify-content:center;align-items:center}.tag[data-v-430cef3e]{min-width:50px;padding:10px;background:#90ee90;margin:3px;border-radius:10px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-430cef3e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/assets/Dynamic/app/confessions/comps/confessionitem.vue
// module id = 581
// module chunks = 0